import axios from "axios";
import config from "./config";

const env = process.env.NODE_ENV || "development";
const stage = config[env];
const API_URL = stage.base_url + "/";

const search = (query) => {
  return axios.get(API_URL + `search?query=${encodeURIComponent(query)}`);
};


// const getCurrentUser = () => {
//   return JSON.parse(localStorage.getItem("user"));
// };

export default {
    search,
};
